<template>
  <span
    ref="anchor"
    class="b44-help"
    :class="{ open }"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
    @focusin="onEnter"
    @focusout="onLeave"
  >
    <button
      type="button"
      class="b44-help-btn acao-secundaria"
      :aria-label="ariaLabel"
      :aria-expanded="open ? 'true' : 'false'"
      @click.stop.prevent="toggle"
    >
      ?
    </button>
    <Teleport to="body">
      <div
        v-show="open"
        class="b44-help-pop b44-help-pop--portal"
        :class="{ wide }"
        role="tooltip"
        :style="popStyle"
        @mouseenter="onEnter"
        @mouseleave="onLeave"
      >
        <div class="b44-help-pop-body" v-html="htmlText"></div>
      </div>
    </Teleport>
  </span>
</template>

<script>
import { helpText } from "@/utils/roboflexHelpTexts";

export default {
  name: "HelpTip",
  props: {
    tip: { type: String, required: true },
    textOverride: { type: String, default: "" },
    ariaLabel: { type: String, default: "Mais informações" },
    /** Painel mais largo (textos longos, ex.: critérios) */
    wide: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
      popStyle: {},
      closeTimer: null,
    };
  },
  computed: {
    text() {
      return this.textOverride || helpText(this.tip) || this.tip;
    },
    htmlText() {
      return String(this.text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n\n/g, "</p><p>")
        .replace(/\n/g, "<br>")
        .replace(/^/, "<p>")
        .replace(/$/, "</p>");
    },
  },
  beforeUnmount() {
    clearTimeout(this.closeTimer);
    window.removeEventListener("scroll", this.reposition, true);
    window.removeEventListener("resize", this.reposition);
  },
  methods: {
    onEnter() {
      clearTimeout(this.closeTimer);
      this.open = true;
      this.$nextTick(() => this.reposition());
      window.addEventListener("scroll", this.reposition, true);
      window.addEventListener("resize", this.reposition);
    },
    onLeave() {
      this.closeTimer = setTimeout(() => {
        this.open = false;
        window.removeEventListener("scroll", this.reposition, true);
        window.removeEventListener("resize", this.reposition);
      }, 120);
    },
    toggle() {
      if (this.open) this.onLeave();
      else this.onEnter();
    },
    reposition() {
      const el = this.$refs.anchor;
      if (!el || !this.open) return;
      const r = el.getBoundingClientRect();
      const width = this.wide ? 360 : 280;
      const margin = 8;
      let left = r.left + r.width / 2 - width / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));

      const spaceBelow = window.innerHeight - r.bottom;
      const preferBelow = spaceBelow > 140 || r.top < 160;
      if (preferBelow) {
        this.popStyle = {
          position: "fixed",
          top: `${r.bottom + 8}px`,
          left: `${left}px`,
          width: `${width}px`,
          bottom: "auto",
        };
      } else {
        this.popStyle = {
          position: "fixed",
          bottom: `${window.innerHeight - r.top + 8}px`,
          left: `${left}px`,
          width: `${width}px`,
          top: "auto",
        };
      }
    },
  },
};
</script>
